<div>
    <div style="background-color: #fafafa;margin: -20px;" class="d-flex justify-content-between mb-2 pl-3 pt-3">
        <h3 class="mb-2 mt-0 font-weight-bold">{{facilityDataView?.facilityName}}</h3>
        <mat-icon (click)="onCloseDialog()" class="cursor mr-2">close</mat-icon>
    </div>
    <div mat-dialog-content>
        <form>
            <div class="container-fluid">
                <div class="form-full-container">
                    <div class="row my-3">
                        <div class="col-xs-12 col-md-6 col-lg-4 col-xl-4">
                            <div class="d-flex justify-content-between w-160">
                                <label class="d-block">{{'CRM Account Id'|translate}}</label>
                                <mat-icon *ngIf="mode =='Edit'" class="info text-left d-flex align-items-center ml-3" aria-hidden="false" [popover]="popTemplate"
                                    [outsideClick]="true" [adaptivePosition]="false" placement="right">info </mat-icon>
                                <ng-template #popTemplate>
                                    <div>
                                        <div class="col">
                                            <div class="p-2 h-200">This is your existing Hartmann Account number which you can find on your printed
                                                invoices
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </div>

                            <div>
                                {{facilityDataView?.facilityCRMId === null ? 'N/A' : facilityDataView?.facilityCRMId}}
                            </div>
                        </div>
                        <div class="col-xs-12 col-md-6 col-lg-4 col-xl-4">
                            <label class="d-block">{{'SAP Account Id'|translate}}</label>
                            <div>{{facilityDataView?.facilitySAPNo}}</div>
                        </div>
                        <div class="col-xs-12 col-md-6 col-lg-4 col-xl-4">
                            <label class="d-block">{{'Customername'|translate}}</label>
                            <div>{{facilityDataView?.facilityName}}</div>
                        </div>
                    </div>
                    <div class="row my-3">

                        <div class="col-xs-12 col-md-6 col-lg-4 col-xl-4">
                            <label class="d-block">{{'Email'|translate}} </label>
                            <div class="eclip-clss">
                                {{(facilityDataView?.contactEmail === null || facilityDataView?.contactEmail === '') ? 'N/A' : facilityDataView?.contactEmail}}
                            </div>
                        </div>
                        <div class="col-xs-12 col-md-6 col-lg-4 col-xl-4">
                            <label class="d-block">{{'Landline'|translate}}</label>
                            <div>
                                {{(facilityDataView?.contactPhone === null || facilityDataView?.contactPhone === '') ? 'N/A' : facilityDataView?.contactPhone}}
                            </div>
                        </div>
                        <div class="col-xs-12 col-md-6 col-lg-4 col-xl-4">
                            <label class="d-block">{{'Optional phone'|translate}}</label>
                            <div>
                                {{(facilityDataView?.alternativePhone === null || facilityDataView?.alternativePhone === '') ? 'N/A' : facilityDataView?.alternativePhone}}
                            </div>
                        </div>
                    </div>
                    <div class="row my-3">
                        <div class="col-xs-12 col-md-12 col-lg-4 col-xl-4">
                            <label class="d-block">{{'Status'|translate}}</label>

                            <div>
                                <span class="d-flex align-items-center" *ngIf="facilityDataView?.isActive">
                                    <mat-icon class="text-success  mr-2">check_circle_outline</mat-icon>
                                    {{'Active'|translate}}
                                </span>
                                <span class="d-flex align-items-center" *ngIf="!facilityDataView?.isActive">
                                    <mat-icon class="text-danger  mr-2">highlight_off</mat-icon>
                                    {{'Inactive'|translate}}
                                </span>
                            </div>
                        </div>
                        <div class="col-xs-12 col-md-12 col-lg-4 col-xl-4">
                            <label class="d-block">{{'Institutionaddress'|translate}}</label>
                            <div>
                                {{facilityDataView?.headOfficeAddress === null ? 'N/A' : facilityDataView?.headOfficeAddress}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div mat-dialog-actions class="d-flex mb-2 justify-content-center mt-3">
        <button (click)="onCloseDialog()" mat-raised-button type="submit" color="primary" class="card-header-action mr-3">OK</button>
    </div>
</div>